

export const ProductSection=()=>{
    
    
    return(
        <div className="producst-section">
            <div className="__container">
                <div className="product-section_row">
                    <div className="product-section_fire-row">
                        <div>
                            <img src={require('../../../../static/IMAGE-products-circle-file.png')}/>
                        </div>
                        <div>
                            <img src={require('../../../../static/IMAGE-products-main-fire.png')}/>
                        </div>
                        <div>
                            <img src={require('../../../../static/IMAGE-products-circle-file.png')}/>
                        </div>
                        <div>
                            <img src={require('../../../../static/IMAGE-products-main-fire.png')}/>
                        </div>
                    </div>
                    <div className="product-section_cards-row">
                        {[1,2,3].map(p=>
                            <div key={p} className="product-section_card">
                                <img className='product-section_card-bg ' src={require('../../../../static/IMAGEproduct-bg-card.png')}/>
                                <div className="product-section_card-content">
                                    <h4>TANGY AND TINGLY</h4>
                                    <h2>LIGHT ROAST BLEND</h2>
                                    <div className='product-section_card-image'>
                                        <img src={require('../../../../static/IMAGE-products-image.png')}/>
                                    </div>
                                </div> 
                            </div>
                        )}
                        
                    </div>
                </div>
            </div>
        </div>
    )
}